import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Role } from '@mytypes';
import { Response as RoleResponse } from '~/common/types/apiResponse/role';
import { fetchRoles } from '~/api';

type RolesState = Role[];

const initialState: RolesState = [];

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    initialize: () => initialState,
  },
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchRoles.fulfilled.type]: (state, action: PayloadAction<RoleResponse>) =>
      action.payload.result,
  },
});

// reducerをexportする
export default rolesSlice.reducer;
